import API from "../API";

const buildQuery = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, value);
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

export const sendEmailOtpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/otp`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetEmailResendOtpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/resend/otp`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const doEmailLoginOtpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/otp/login`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const forgotPasswordApi = async (payload) => {
  try {
    const email = typeof payload === "string" ? payload : payload?.email;
    const response = await API.put(
      `/auth/auth/forgotpassword${buildQuery({ email })}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const socialSignUpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/social/signup`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const signUpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/signup`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const refreshTokenApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/refresh-token`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const loginApi = async (payload) => {
  try {
    const response = await API.post(`/auth/auth/login`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyTokenApi = async () => {
  try {
    const response = await API.get(`/auth/auth/verify-token`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getChangePasswordTokenApi = async (payload) => {
  try {
    const token = typeof payload === "string" ? payload : payload?.token;
    const response = await API.get(
      `/auth/auth/user/changePassword${buildQuery({ token })}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
